import React, { Component } from "react";
import styled from 'styled-components/macro'
import { Link } from "react-router-dom";
import { mobile } from "../../theme/index";
import * as PubSub from "pubsub-js";
import { disableScroll, enableScroll } from "./scrollHelper";

export const MENU_OPEN_EVENT = "MENU_OPEN_EVENT";
export const MENU_ENTRY_CLICKED_EVENT = "MENU_ENTRY_CLICKED_EVENT";

const Wrapper = styled.menu`
  display: none;

  ${mobile`
    display: inline-flex;
    flex-direction: column;
    position: fixed;
    background-color: rgba(${p => p.theme.color.primary});
    top: ${p => p.theme.header.height};
    right: 0;
    z-index: 1;
    border-radius: 0 0 0 5px;
    box-shadow: -2px 2px 10px 0 rgba(${p => p.theme.color.text.primary}, 0.4);
    transform: translateX(${p => p.open ? "0" : "110%"});
    transition: all 0.5s;
    margin: 0;
    padding: 0;
  `}
`;

const MenuLink = styled(Link)`
  outline: none;
  text-decoration: none;
  color: rgba(${p => p.theme.color.light});
  font-size: 1.25em;
  padding: 10px 25px;
`;
const StyledSubMenuLinkText = styled.div`
    font-size: 0.7em;
`;

export default class MobileMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  componentDidMount() {
    const menuOpenerSubscriber = (msg, data) => {
      console.debug(MENU_OPEN_EVENT + " catched.");
      if (data) {
        disableScroll();
      } else {
        enableScroll();
      }
      this.setState({
        isOpen: data,
      });
    };
    PubSub.subscribe(MENU_OPEN_EVENT, menuOpenerSubscriber);
  }

  render() {
    return (
      <Wrapper open={ this.state.isOpen }>
        { this.props.menu.map(entry => (
          <MenuLink
            key={ entry.to }
            to={ entry.to }
            onClick={ () => { PubSub.publish(MENU_ENTRY_CLICKED_EVENT, entry); } }>
            { entry.title }
            <StyledSubMenuLinkText>{ entry.subtitle }</StyledSubMenuLinkText>
          </MenuLink>
          )) }
      </Wrapper>
    );
  }
}